import { MileageUsableInfo } from '../components/MileageUableInfo';
import { useMileageUsableInfoService } from '../services/useMileageUsableInfoService';

export const MileageUsableInfoContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const service = useMileageUsableInfoService();

  if (service.isHide) {
    return null;
  }

  return (
    <MileageUsableInfo
      shopName={service.shopName}
      sellerSpecificUseMileageRate={service.sellerSpecificUseMileageRate}
      defaultUseMileageRate={service.defaultUseMileageRate}
      totalUseMileageRate={service.totalUseMileageRate}
    />
  );
};
